export default "__VITE_ASSET__C0r5EAWv__"